import { ApiError } from "./ApiError";
import { getAuthHeaders } from "./api";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "https://stg-native-api.cleverpe.com/api";


/*
 * =========================================================
 * FETCH APPLICABLE SCHEMES
 * =========================================================
 *
 * POST /scheme/fetch
 *
 * Request body:
 * {
 *     lender: "CAPRION",
 *     amount: 30000
 * }
 *
 * The backend uses the journeyId from the JWT to identify
 * the current journey/order and fetches applicable schemes.
 *
 * =========================================================
 */

export interface FetchSchemesRequest {
    lender: string;
    amount: number;
}


export interface SchemeData {
    _id?: string;
    schemeId?: string;
    name: string;

    grossTenure: number;
    advancedEMI: number;

    subventionCost: number;

    interestBased: boolean;
    annualInterest: number;

    processingRate: number;
    GST: number;

    min: number;
    calOnRootAmt: boolean;

    for: string[];
    lender: string[];
    category: string[];

    isActive: boolean;
}


export interface SchemeCalculation {
    loanAmount: number;
    grossTenure: number;
    advancedEMI: number;
    NoOfNetEmis: number;
    netLoanAmount: number;
    customerROI: number;
    totalProcessingFee: number;
    monthlyEMI: number;
    totalInterest: number;
    totalDownPayment: number;
    advancedEmiPayment: number;
    DBDToDealer: number;
    DealerGets: number;
    netDisbursement: number;
    name: string;
}


export interface CalculatedScheme {
    amount: number;
    scheme: SchemeData;
    calculations: SchemeCalculation;
}


export interface FetchSchemesResponse {
    success: boolean;

    data: {
        amount: number;
        availableSchemes: CalculatedScheme[];
    };
}


export const fetchApplicableSchemes = async (
    request: FetchSchemesRequest
): Promise<FetchSchemesResponse> => {

    const token =
        localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/scheme/fetch`,
        {
            method: "POST",

            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },

            body: JSON.stringify(request),
        }
    );

    const data =
        await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to fetch applicable schemes.",
            response.status,
            data
        );
    }

    return data;
};